module.exports = __webpack_public_path__ + "static/media/forklift.008d9960.jpg";